<!-- 折线图 -->
<style lang="stylus" scoped>
.bar-wrap {
  width: 100%;
  height: 334px;
  padding: 18px 0;
}

.list {
  display: flex;
  flex-wrap: wrap;
  color: rgba(119, 202, 216, 1);
  font-size: 14px;
  padding: 0 40px;
  box-sizing: border-box;

  li {
    width: 60px;
    height: 32px;
    text-align: center;
    line-height: 32px;
  }

  .active {
    background: rgba(36, 67, 191, 1);
    border: 1px solid rgba(119, 202, 216, 1);
    font-size: 18px;
    font-weight: bold;
    color: #fff;
    line-height: 30px;
  }
}

.lines {
  height: 250px;

  .main {
    width: 100%;
    height: 250px;
  }

  .main1 {
    width: 100%;
    height: 250px;
  }
}
</style>

<template>
  <boxWrap :name="name">
    <div class="bar-wrap">
      <ul class="list" id="list">
        <li :class="[{['active']: item.flag}]" v-for="(item,index) in list" :key="index">{{item.name}}</li>
      </ul>
      <div class="lines">
        <div v-if="num % 2 ===0" class="main"></div>
        <div v-else class="main1"></div>
      </div>
    </div>
  </boxWrap>
</template>

<script>
import echarts from 'echarts'
import boxWrap from 'components/dashboard/common/boxWrap';
export default {
  data() {
    var i = 0
    return {
      myChart: {},
      name: '赋码趋势图',
      list: [
        { name: '右江区', flag: true },
        { name: '靖西市', flag: false },
        { name: '田阳县', flag: false },
        { name: '田东县', flag: false },
        { name: '平果县', flag: false },
        { name: '德保县', flag: false },
        { name: '那坡县', flag: false },
        { name: '凌云县', flag: false },
        { name: '乐业县', flag: false },
        { name: '西林县', flag: false },
        { name: '隆林县', flag: false },
        { name: '田林县', flag: false }],
      num: 1,
      colorList: [
        new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
          offset: 0,
          color: '#FCC849'
        }, {
          offset: 0.8,
          color: '#FF8801'
        }], false),
        new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
          offset: 0,
          color: '#C4F4FA'
        }, {
          offset: 0.8,
          color: '#04CBE2'
        }], false)
      ]
    }
  },
  components: {
    boxWrap
  },
  methods: {
    init() {
      window.addEventListener('resize', function () {
        this.myChart.resize()
      }.bind(this))
    },
    setActive() {
      var len = this.list.length
      const that = this;
      setTimeout(function () {
        that.list[(that.num - 1) % len].flag = false
        that.list[that.num % len].flag = true
        that.num++
        that.setActive()
      }, 2000)
    },
    setCharts() {
      const that = this;
      setTimeout(function () {
        that.charts()
        that.setCharts()
      }, 2000)
    },
    charts() {
      if (this.num % 2 === 0) {
        this.myChart = echarts.init(document.querySelector('.lines .main'));
      } else {
        this.myChart1 = echarts.init(document.querySelector('.lines .main1'));
      }
      const option = {
        xAxis: {
          type: 'category',
          boundaryGap: false,
          data: ['1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11', '12'],
          axisTick: {
            show: false
          },
          axisLine: {
            show: true,
            lineStyle: {
              color: "#00c7ff",
              width: 1,
              type: "solid"
            }
          },
          splitLine: {
            show: false
          }
        },
        yAxis: {
          type: 'value',
          axisTick: {
            show: false
          },
          axisLine: {
            show: true,
            lineStyle: {
              color: "#00c7ff",
              width: 1,
              type: "solid"
            }
          },
          splitLine: {
            show: false,
            lineStyle: {
              color: "#4797FA",
              width: 1,
              type: "solid"
            }
          }
        },
        series: [{
          data: [820, 932, 901, 934, 1290, 1330, 1320, 901, 934, 1290, 1330, 1320],
          type: 'line',
          stack: 'area',
          smooth: true,
          symbolSize: 0,
          lineStyle: {
            normal: {
              width: 0
            }
          },
          areaStyle: {
            normal: {
              color: this.colorList[this.num % 2],
              shadowColor: 'rgba(0, 0, 0, 0.1)',
              shadowBlur: 10
            }
          },
          itemStyle: {
            normal: {
              color: '#FF8801'
            }
          }
        }]
      }
      if (this.num % 2 === 0) {
        this.myChart.setOption(option)
      } else {
        this.myChart1.setOption(option)
      }
    }
  },
  mounted() {
    this.charts()
    this.setCharts()
    this.init();
    this.setActive()
  }
}

</script>


// WEBPACK FOOTER //
// index.vue?579d92c2